import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormValidatorsService {
  constructor() {}

  static onlyStringValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    const value = control.value;

    if (typeof value !== 'string' || /\d/.test(value)) {
      return { onlyString: 'Inserire solo lettere.' };
    }
    return null; // Valore valido
  }

  static onlyNumberValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    // const value = control.value;

    // if (typeof value !== 'string' || isNaN(Number(value))) {
    //   return { onlyNumber: 'Inserire solo numeri.' };
    // }

    // return null; // Valore valido
    const value = control.value;

    if (!value || !/^\+?\d{6,15}$/.test(value)) {
      return { onlyNumber: 'Sono permessi solo numeri.' };
    }

    return null;
  }
}
